import {
  ActionReducer,
  ActionReducerMap,
  MetaReducer
} from '@ngrx/store';

import {localStorageSync} from 'ngrx-store-localstorage';

import { environment } from '../../environments/environment';
import * as fromFilter from './reducers/filter.reducer';
import * as fromUser from "./reducers/user.reducer";
import * as fromPage from "./reducers/page.reducer";
import * as fromTeacher from "./reducers/teacher.reducer";
import * as fromStudent from "./reducers/student.reducer";
import * as fromRookie from "./reducers/rookie.reducer";

export interface AppState {
  [fromFilter.filterFeatureKey]: fromFilter.FilterState;
  [fromUser.userFeatureKey]: fromUser.UserState;
  [fromPage.pageFeatureKey]: fromPage.PageState;
  [fromTeacher.teacherFeatureKey]: fromTeacher.TeacherState;
  [fromStudent.studentFeatureKey]: fromStudent.StudentState;
  [fromRookie.rookieFeatureKey]: fromRookie.RookieState;
}

export const reducers: ActionReducerMap<AppState> = {
  [fromFilter.filterFeatureKey]: fromFilter.reducer,
  [fromUser.userFeatureKey]: fromUser.reducer,
  [fromPage.pageFeatureKey]: fromPage.reducer,
  [fromTeacher.teacherFeatureKey]: fromTeacher.reducer,
  [fromStudent.studentFeatureKey]: fromStudent.reducer,
  [fromRookie.rookieFeatureKey]: fromRookie.reducer
};

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: [fromUser.userFeatureKey, fromStudent.studentFeatureKey, fromRookie.rookieFeatureKey],
    rehydrate: true
  })(reducer);
}

// export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];
export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];
